import React from 'react';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const testimonials = [
    {
      quote: 'TM RUSH®/Marcas Já streamlined our registration. The process was efficient, cost-effective, and the platform is incredibly user-friendly.',
      author: 'DANILO L. NUNES',
      role: 'CEO, DCS Facilities',
      image: '/images/people/danilo.png',
      companyLogo: '/images/people/empresas/dc.png',
    },
    {
      quote: 'Excellent! We needed a strategic solution without the high fees of traditional firms. They delivered high-quality service with a budget that made sense for our company.',
      author: 'Rui Bastian',
      role: 'Managing Partner, JOG Engenharia de Andaimes',
      image: '/images/people/rui.png',
      companyLogo: '/images/people/empresas/jog.png',
    },
    {
      quote: 'Securing our trademark brought immediate credibility to our brand. The team provided security and clarity throughout the entire process.',
      author: 'Rafael S. Cerqueira',
      role: 'Managing Partner, Linkjur',
      image: '/images/people/rafael.png',
      companyLogo: '/images/people/empresas/linkjur.png',
    },
    {
      quote: 'I was impressed by the speed and security of the system. The support team answered all my technical questions instantly. Highly satisfied.',
      author: 'Luiz Felipe Regadas',
      role: 'CEO, Quesam Tech',
      image: '/images/people/luiz.png',
      companyLogo: '/images/people/empresas/quesan.png',
    },
  ];

  return (
    <section id="what-our-clients-say" className="py-20 bg-background-auxiliary scroll-mt-24 relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-4">
            What our clients say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-background-white rounded-2xl p-8 shadow-sm hover:shadow-md border border-gray-100/50"
            >
              <div className="flex items-center gap-4 mb-4">
                {/* Logo da empresa */}
                {testimonial.companyLogo && (
                  <img 
                    src={testimonial.companyLogo} 
                    alt="Company logo"
                    className="h-8 w-auto object-contain mix-blend-multiply"
                  />
                )}
                {/* Estrelas */}
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-yellow-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-text/80 mb-6 leading-relaxed italic">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-text">{testimonial.author}</p>
                  <p className="text-sm text-text/60">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-text/70 mb-4">
          We hold a 5-Star Rating on Google Reviews. These reviews reflect the excellence of Marcas Já, our operating powerhouse in Brazil, with 14,000+ trademarks filed.
          {' '}
            <a 
              href="https://www.google.com/search?q=marcas+ja&oq=marcas+ja&aqs=chrome..69i57j69i60l4j69i65l2j69i60.2934j0j4&sourceid=chrome&ie=UTF-8#lrd=0x951979230513ffb1:0xeabfb027e171e109,1,,,"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary-hover underline"
            >
              See our Reviews on Google
            </a>
          </p>
          <Link
            to="/order"
            className="inline-block bg-primary text-white px-10 py-4 rounded-xl hover:bg-primary-hover font-semibold shadow-md hover:shadow-lg"
          >
            Start Application
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
